import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { DocumentCustomerPortal } from "Util/enums";

export const Container = styled("div")({
  justifyContent: "center",
  borderRadius: "8px",
  backgroundColor: "#f9fafb",
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  padding: "12px 16px",
});

export const ContainerTitle = styled("div")({
  display: "flex",
  gap: "15px",
  "@media (max-width: 991px)": {
    flexWrap: "wrap",
  },
});

export const Title = styled("span")({
  color: "#1d2939",
  letterSpacing: "0.15px",
  flex: 1,
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "150%",
  fontFamily: "Manrope, sans-serif",
  "@media (max-width: 991px)": {
    maxWidth: "100%",
  },
});

export const BadgeStatus = styled("span")(({ type }: { type: string }) => {
  const typeConfigDictionary = {
    [DocumentCustomerPortal.UPLOADED]: {
      color: "#039855",
      backgroundColor: "#ecfdf3",
    },
    [DocumentCustomerPortal.MISSING]: {
      backgroundColor: "#FEF3F2",
      color: "#D92D20",
    },
    [DocumentCustomerPortal.MISSING_SHIPMENT]: {
      backgroundColor: "#FFFAEB",
      color: "#DC6803",
    },
    [DocumentCustomerPortal.CANCELLED]: {
      color: colors.gray600,
      backgroundColor: "#F9FAFB",
    },
  };

  return {
    ...typeConfigDictionary[type as keyof typeof typeConfigDictionary],
    borderRadius: "4px",
    mixBlendMode: "multiply",

    whiteSpace: "nowrap",
    letterSpacing: "0.5px",
    justifyContent: "center",
    padding: "4px 8px",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "133%",
    fontFamily: "Manrope, sans-serif",
    "@media (max-width: 991px)": {
      whiteSpace: "initial",
    },
  };
});

export const ContainerInfo = styled("div")({
  display: "flex",
  marginTop: "16px",
  gap: "15px",
  "@media (max-width: 991px)": {
    flexWrap: "wrap",
  },
});

export const GridDates = styled("div")(({ theme }) => {
  return {
    display: "flex",
    gap: "20px",
    flex: 1,
    flexDirection: "column",

    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  };
});

export const ContainerColumnDates = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const TitleInfo = styled("span")({
  color: "#475467",
  letterSpacing: "0.4px",
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "133%",
  fontFamily: "Manrope, sans-serif",
});

export const SubTitleInfo = styled("span")({
  color: "#1d2939",
  letterSpacing: "0.25px",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  fontFamily: "Manrope, sans-serif",
});

export const ContainerGapDates = styled("div")({
  display: "flex",
  gap: "4px",
});

export const ContainerButtonFile = styled("div")(({ disabled }: { disabled?: boolean }) => ({
  justifyContent: "flex-end",
  display: "flex",
  gap: "8px",
  fontSize: "14px",
  color: disabled ? "#98A2B3" : "#0055a4",
  fontWeight: 600,
  textAlign: "center",
  letterSpacing: "0.1px",
  lineHeight: "143%",
  margin: "auto 0",
  padding: "10px 12px",
  cursor: disabled ? "not-allowed" : "pointer",
}));

export const Img = styled("img")({
  aspectRatio: "1",
  objectPosition: "center",
  width: "20px",
});

export const ButtonText = styled("span")({
  fontFamily: "Manrope, sans-serif",
});

export const SimpleText = styled("span")(({ theme }) => ({
  color: theme.palette.primary.main,
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));
